import React from 'react';
import { Modal, Box, Typography, IconButton, Paper } from '@mui/material';
import { Close } from '@mui/icons-material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '60%',
  maxWidth: 500,
  bgcolor: 'background.paper',
  borderRadius: '16px',
  boxShadow: 24,
  p: 2.5,
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5,
};

export default function MediaResourceModal({ open, onClose, mediaResource }) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="media-resource-modal-title"
      aria-describedby="media-resource-modal-description"
    >
      <Box sx={style}>
        <Box sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          width: '100%',
          mb: 1
        }}>
          <IconButton
            sx={{
              bgcolor: 'background.paper',
              boxShadow: 1,
              '&:hover': {
                bgcolor: 'background.paper',
                opacity: 0.9
              }
            }}
            onClick={onClose}
          >
            <Close />
          </IconButton>
        </Box>

        {mediaResource && (
          <>
            <Paper
              elevation={3}
              sx={{
                width: '100%',
                overflow: 'hidden',
                borderRadius: '12px'
              }}
            >
              <img
                src={mediaResource.resource_url}
                alt={mediaResource.file_name}
                style={{
                  width: '100%',
                  height: 'auto',
                  maxHeight: '60vh',
                  objectFit: 'contain',
                  display: 'block'
                }}
              />
            </Paper>

            <Box sx={{ textAlign: 'center', px: 2 }}>
              <Typography
                id="media-resource-modal-title"
                variant="h5"
                component="h2"
                sx={{
                  fontWeight: 600,
                  mb: 1
                }}
              >
                {mediaResource.name}
              </Typography>
              <Typography
                id="media-resource-modal-description"
                variant="body1"
                sx={{
                  color: 'text.secondary',
                  maxWidth: '600px',
                  mx: 'auto'
                }}
              >
                {mediaResource.description}
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Modal>
  );
}
